import { MouseEvent, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import { NavLink, Link as RouterLink } from "react-router-dom";
import UserMenu from "./UserMenu";

const navItems = [
  { label: "Dashboard", path: "/" },
  { label: "Logs", path: "/logs" },
  { label: "Pricing", path: "/pricing" },
  { label: "About", path: "/about" },
];

const NavBar = () => {
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="sticky" elevation={0}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <ElectricBoltIcon
            sx={{ display: { xs: "none", md: "flex" }, mr: 1 }}
          />
          <Typography
            variant="h6"
            noWrap
            component={RouterLink}
            to="/"
            sx={{
              mr: 3,
              display: { xs: "none", md: "flex" },
              fontFamily: "Sora, DM Sans, sans-serif",
              fontWeight: 700,
              letterSpacing: ".12rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            SmartPower
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="open navigation"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {navItems.map((item) => (
                <MenuItem
                  key={item.label}
                  component={NavLink}
                  to={item.path}
                  onClick={handleCloseNavMenu}
                  sx={{ "&.active": { color: "primary.main" } }}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <ElectricBoltIcon
            sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}
          />
          <Typography
            variant="h6"
            noWrap
            component={RouterLink}
            to="/"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "Sora, DM Sans, sans-serif",
              fontWeight: 700,
              letterSpacing: ".12rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            SmartPower
          </Typography>

          <Box
            sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, gap: 1 }}
          >
            {navItems.map((item) => (
              <Button
                key={item.label}
                component={NavLink}
                to={item.path}
                end={item.path === "/"}
                sx={{
                  my: 2,
                  color: "white",
                  "&.active": {
                    color: "secondary.main",
                    backgroundColor: "rgba(240, 168, 50, 0.15)",
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <UserMenu />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NavBar;
